// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.pagenotfound_container_pagenotfound__cOYik {
  width: 60%;
  margin-top: 3%; 
  margin-left: 15%; 
  display: flex; 
  flex: 1 1; 
  flex-direction: column; 
  align-content: flex-center;
  align-items: center;
  align-self: center; }


.pagenotfound_links__sVXcq {
  font-family: Futura LT Book;
  font-size: 18px;
  line-height: 36px;
  letter-spacing: 0.07em;
  text-align: center;
  color: #415167; }
`, "",{"version":3,"sources":["webpack://./src/pages/PageNotFound/pagenotfound.module.css"],"names":[],"mappings":";AACA;EACE,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB,EAAE;;;AAGtB;EACE,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc,EAAE","sourcesContent":["\r\n.container_pagenotfound {\r\n  width: 60%;\r\n  margin-top: 3%; \r\n  margin-left: 15%; \r\n  display: flex; \r\n  flex: 1; \r\n  flex-direction: column; \r\n  align-content: flex-center;\r\n  align-items: center;\r\n  align-self: center; }\r\n\r\n\r\n.links {\r\n  font-family: Futura LT Book;\r\n  font-size: 18px;\r\n  line-height: 36px;\r\n  letter-spacing: 0.07em;\r\n  text-align: center;\r\n  color: #415167; }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container_pagenotfound": `pagenotfound_container_pagenotfound__cOYik`,
	"links": `pagenotfound_links__sVXcq`
};
export default ___CSS_LOADER_EXPORT___;
